@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
}

@if (showSustainabilityLoan()) {
    <sustainability-loan></sustainability-loan>
}
@if (showSustainabilityAmount()) {
    <sustainability-amount></sustainability-amount>
}
